import * as types from '../actions/actionTypes';
import initialState from './initialState';


export default function pagoReporteReducer(state= initialState.pagoReporte, action){
    let newState=[];
	switch(action.type){
        case types.LOAD_PAGOS_PENDIENTES_LIST_SUCCESS:
            //console.log(action);
            return action.pagos;
            
            return newState;

       default:
			return state;
	}
}